// extracted by mini-css-extract-plugin
export default {"header":"PrahaTable_header__2gl7R","grid":"PrahaTable_grid__ZSVfH","input":"PrahaTable_input__84AXQ","title":"PrahaTable_title__CLDsR","content":"PrahaTable_content__USNHD"};